import React from 'react'
import regression from 'regression'
import R from 'ramda'
import { line } from 'd3-shape'
import styled from 'styled-components'

const RegressionPath = styled.path`
  fill: none;
  stroke: ${props => props.color || 'steelblue'};
  stroke-width: 2px;
`
const RegressionLabel = styled.text`
  text-anchor: end;
  font-weight: bold;
  fill: steelblue;
`

const toPredictions = regressionResult =>
  R.compose(
    R.map(([x, y]) => ({ x, y })),
    R.map(x => regressionResult.predict(x))
  )

const RegressionLine = ({
  data,
  x,
  y,
  xGetter,
  yGetter,
  measurement,
  xMin,
  xMax,
}) => {
  const { margin, innerWidth } = measurement
  const points = R.map(d => [x(xGetter(d)), y(yGetter(d))], data)

  const linear = regression.linear(points)
  const xValues = [x(xMin), x(xMax)]
  const identityLine = line()
    .x(d => d.x)
    .y(d => d.y)
  const linearPath = identityLine(toPredictions(linear)(xValues))

  return (
    <g transform={`translate(${margin.left},${margin.top})`}>
      <RegressionPath d={linearPath} />
      <RegressionLabel y="-10" x={innerWidth}>
        Linear Regression {linear.string} with R2 = {linear.r2}
      </RegressionLabel>
    </g>
  )
}

export default RegressionLine
